import { navV3Messages } from '@/components/layout/Navigation/nav-v3/nav-v3.messages';
import { NavItem } from '@/components/layout/Navigation/sidebar/nav-item';
import { IS_EVIDENCE_LIBRARY_ENABLED } from '@/features/flags/legacy-flags';
import { Library } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../../mobile/use-mobile-panel';

/**
 * Nav-v3 "Library" entry — the Evidence library at /library. Rebuilt here
 * because the existing link lives inside the quarantined ChatSidebar.
 */
export const LibraryNavItem = () => {
  const intl = useIntl();
  const { dismissMobileSidebar } = useMobilePanel();

  if (!IS_EVIDENCE_LIBRARY_ENABLED()) {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage(navV3Messages.library)}
      icon={<Library />}
      href="/library"
      onClick={dismissMobileSidebar}
      testId="sidebar-link-library"
    />
  );
};
